"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AuditLogHeaderDirective;

var _auditLogHeaderTpl = require("./audit-log-header.tpl.html");

var _auditLogHeaderTpl2 = _interopRequireDefault(_auditLogHeaderTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function AuditLogHeaderDirective($compile, $templateCache, types) {

    var linker = function linker(scope, element, attrs) {

        var template = $templateCache.get(_auditLogHeaderTpl2.default);
        element.html(template);
        scope.auditLogMode = attrs.auditLogMode;
        scope.types = types;
        $compile(element.contents())(scope);
    };

    return {
        restrict: "A",
        replace: false,
        link: linker,
        scope: false
    };
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/audit/audit-log-header.directive.js